import { render, staticRenderFns } from "./CorrectiveActionIndex.vue?vue&type=template&id=216866ce"
import script from "./CorrectiveActionIndex.vue?vue&type=script&lang=js"
export * from "./CorrectiveActionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports